import { useState, useReducer, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { SelectBox, RadioGroup } from "devextreme-react";
import { NumberBox } from "devextreme-react/number-box";
import { getTheme } from "../highChartTheme";

import * as actions from "../../../actions/schAttainment";
import schAttainmentReducer from "../../../reducers/schAttainment";

const initState = { missReasonCodeFrequency: [] };

const ParetoChart = (props) => {
  const [animate, setAnimate] = useState("");
  const [missReason, setMissReason] = useState([]);
  // const [missFrequency, setMissFrequency] = useState([]);
  const [colorCode, setColorCode] = useState([]);
  const [reasonLevel, setReasonLevel] = useState(0);
  const [isCascaded, setIsCascaded] = useState(true);
  const [numberOfReasons, setNumberOfReasons] = useState(15);
  const isLightMode = useSelector((state) => state.theme.lightMode);

  const [state, dispatch] = useReducer(schAttainmentReducer, initState);

  const { tierId, isRefreshDataRequired } = props;

  const { missReasonCodeFrequency } = state;

  useEffect(() => {
    actions.fetchSchAttainmentMissReasonCodeFrequency(dispatch, {
      // schAttainmentId: "0",
      tierId,
      startDate: moment().subtract("60", "days").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      reasonLevel,
      rowCount: numberOfReasons,
      isCascaded: String(isCascaded),
    });
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, [isRefreshDataRequired, reasonLevel, numberOfReasons, isCascaded]);

  useEffect(() => {
    if (missReasonCodeFrequency.length) {
      const missReasonData = missReasonCodeFrequency?.map((x) => {
        return [x.reasonCode, parseInt(x.frequency)];
      });
      const missReasonColorData = missReasonCodeFrequency?.map((x) => {
        return [x.colorCode];
      });
      setMissReason(missReasonData?.map(([reasonCode]) => reasonCode));
      // setMissFrequency(missReasonData?.map(([frequency]) => frequency));
      setColorCode(missReasonColorData?.map(([colorCode]) => colorCode));
    }
  }, [missReasonCodeFrequency]);

  const options = {
    chart: {
      type: "column",
    },
    tooltip: {
      shared: true,
    },
    series: [
      {
        showInLegend: false,
        name: "",
        type: "column",
        colorByPoint: true,
        colors: colorCode,
        data: missReasonCodeFrequency?.map((x) => {
          return [x.reasonCode, parseInt(x.frequency)];
        }),
      },
    ],
  };

  return (
    <div className="site-view tier-wrap admin-console-wrapper">
      <div
        className={"site-list " + animate}
        style={{
          backgroundColor: isLightMode ? "#d3d3d3" : "#2f3030",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              marginRight: "10px",
            }}
          >
            <span
              style={{
                fontSize: "12px",
              }}
            >
              Number of Reasons
            </span>
            <NumberBox
              min={1}
              width={168}
              step={5}
              showSpinButtons={true}
              value={numberOfReasons}
              onValueChanged={(e) => {
                {
                  if (e.value > 0) {
                    setNumberOfReasons(e.value);
                  }
                }
              }}
            />
          </div>
          <div>
            <span
              style={{
                fontSize: "12px",
              }}
            >
              Select Level
            </span>
            <SelectBox
              dataSource={[
                {
                  label: "Level 0",
                  value: 0,
                },
                {
                  label: "Level 1",
                  value: 1,
                },
                {
                  label: "Level 2",
                  value: 2,
                },
              ]}
              displayExpr="label"
              valueExpr="value"
              wrapItemText={true}
              onValueChanged={(e) => {
                setReasonLevel(e.value);
              }}
              value={reasonLevel}
              width={200}
            />
          </div>
          <div
            style={{
              marginLeft: "10px",
            }}
          >
            <span
              style={{
                fontSize: "12px",
              }}
            >
              Level Drilldown
            </span>
            <RadioGroup
              hint="Level Drilldown"
              items={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              valueExpr="value"
              displayExpr="label"
              onValueChanged={(e) => {
                setIsCascaded(e.value);
              }}
              layout="horizontal"
              value={isCascaded}
              style={{
                marginTop: "10px",
              }}
            />
          </div>
        </div>

        <HighchartsReact
          highcharts={Highcharts}
          options={{
            ...options,
            ...getTheme(
              "Schedule Attainment Reason for Miss - Pareto Chart",
              isLightMode,
              missReason
            ),
          }}
        />
      </div>
    </div>
  );
};

export default ParetoChart;
